var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTotalTurnover = function SvgTotalTurnover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6236FF",
    d: "M6 0h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeDasharray: "0,0",
    strokeWidth: 0.2,
    d: "m16.765 15.23 2.16-2.46a.37.37 0 0 0-.28-.61h-.56a.35.35 0 0 0-.27.12l-1.54 1.76a.365.365 0 0 1-.55 0l-1.54-1.76a.35.35 0 0 0-.27-.12h-.56a.37.37 0 0 0-.28.61l2.16 2.46h-1.94a.373.373 0 0 0-.37.37v.03c0 .203.168.37.37.37h1.94v1.54h-1.94a.365.365 0 0 0-.37.36v.04c0 .203.168.36.37.36h1.94v1.94c0 .203.158.37.36.37h.81c.202 0 .36-.167.36-.37V18.3h1.94c.202 0 .37-.157.37-.36v-.04a.365.365 0 0 0-.37-.36h-1.94V16h1.94c.202 0 .37-.167.37-.37v-.03a.373.373 0 0 0-.37-.37h-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25a9.001 9.001 0 0 1 0-18 9.001 9.001 0 0 1 0 18m-.002-1.683c-4.038 0-7.31-3.282-7.31-7.32a7.31 7.31 0 0 1 7.31-7.31c4.037 0 7.32 3.273 7.32 7.31a7.326 7.326 0 0 1-7.32 7.32"
  })))));
};
export default SvgTotalTurnover;